import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import { StartProgressionDialogViewModel } from './StartProgressionDialogViewModel'
import { JobProgressionFlow } from 'jobs/progression/JobProgression'

interface Props {
  vm: StartProgressionDialogViewModel
}

export default observer(function StartProgressionDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.close}
      dataTest="job-progression-start-dialog"
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_documents.svg')}
              alt="Woman typing on a computer."
            />
          )}
          <ModalSheetContentTitle>
            Do you have all the documents needed to continue{' '}
            {vm.progressionFlow === JobProgressionFlow.REVIEW
              ? 'the review?'
              : 'preparation?'}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            By continuing, you confirm that there are no missing items.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            disabled={vm.startJobProgression.pending}
          >
            Cancel
          </Button>
          <Button
            submit
            loading={vm.startJobProgression.pending}
            disabled={vm.startJobProgression.pending}
            onClick={vm.startJobProgression}
            type="primary"
            dataTest="job-progression-set-job-started-dialog-button"
          >
            {vm.progressionFlow === JobProgressionFlow.REVIEW
              ? 'Continue Review'
              : 'Continue Preparation'}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
